module.exports = __webpack_public_path__ + "static/media/use_esim_zhcn3.ecf0c57f.png";